import React, { useState, useEffect } from 'react';
import { RadioGroup, FormControlLabel, Radio } from '@mui/material';
import ActionDialog from './ActionDialog';

const RejoinableChangeDialog = ({ open, onClose, onConfirm }) => {
  const [isRejoinable, setIsRejoinable] = useState(false);

  useEffect(() => {
    if (open) {
      setIsRejoinable(false);
    }
  }, [open]);

  const handleConfirm = () => {
    onConfirm(isRejoinable);
  };

  return (
    <ActionDialog open={open} onClose={onClose} onConfirm={handleConfirm} title="상태 변경">
      <RadioGroup
        value={isRejoinable ? 'rejoinable' : 'notRejoinable'}
        onChange={(e) => setIsRejoinable(e.target.value === 'rejoinable')}
      >
        <FormControlLabel
          value="notRejoinable"
          control={<Radio size="small" />}
          label="가입불가"
          sx={{
            '& .MuiFormControlLabel-label': {
              fontSize: 14,
            },
          }}
        />
        <FormControlLabel
          value="rejoinable"
          control={<Radio size="small" />}
          label="가입가능"
          sx={{
            '& .MuiFormControlLabel-label': {
              fontSize: 14,
            },
          }}
        />
      </RadioGroup>
    </ActionDialog>
  );
};

export default RejoinableChangeDialog;
